import { t } from "../hooks/translations"
import css from "../style.module.scss"

export const LoadingScreen = function LoadingScreen() {
  return (
    <div className={css["container-aligned"]}>
      <p className={css.paragraph}>{t("loading")}</p>
    </div>
  )
}
